import { dateUtil } from '@Util/date.ts';
import { AccountingPeriod, useFetchAccountingPeriods } from './useFetchAccountingPeriods';
import { useFetchAnnualAccounts } from './useFetchAnnualAccounts';

export function useFetchAccountingPeriodsByAnnualAccounts(
    year: number,
    onSuccess?: (data: Array<AccountingPeriod>) => void,
) {
    const dateFrom = new Date(year, 0, 1);
    const { annualAccounts } = useFetchAnnualAccounts(dateFrom);

    const startDate = dateUtil.parseDate(annualAccounts?.[0]?.start ?? '');
    const endDate = dateUtil.parseDate(annualAccounts?.[0]?.end ?? '');

    return useFetchAccountingPeriods(startDate, endDate, onSuccess);
}
